module.exports = __webpack_public_path__ + "static/img/BK9.bc89236.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/BK9.png
// module id = plBv
// module chunks = 9